<template>
  <NavigationLayout
    :navigationBarStyle="{
      'border-bottom': '1px solid #e8e8e8',
    }"
  >
    <div class="maintenance__wrapper" slot="contents">
      <Maintenance />
    </div>
  </NavigationLayout>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import NavigationLayout from '@/components/NavigationLayout.vue'
import Maintenance from '@/components/Error/Maintenance.vue'
import { api } from '@/api/appGatewayServerApi'
import { checkInMaintenance } from '@/utils/maintenance'

@Component({
  components: {
    NavigationLayout,
    Maintenance,
  },
})
export default class MaintenancePage extends Vue {
  async beforeCreate() {
    try {
      // メンテナンスチェック
      await api().maintenance.allCheck()

      // ローカルストレージからメンテ前に開こうとしていたページのpathを取得
      const redirectPath = localStorage.getItem('targetPathPreMaintenance')

      // 各ページ遷移前にフラグ削除
      sessionStorage.removeItem('isMaintenanceReloaded')

      if (redirectPath) {
        localStorage.removeItem('targetPathPreMaintenance')
        // メンテが終了してる場合は、メンテ前に開こうとしていたページのpathへ遷移させる
        this.$router.push(redirectPath).catch(() => {})
        return
      }

      // メンテ前に開こうとしていたページのpathが取れない場合はmypageへ遷移させる
      this.$router.push('mypage').catch(() => {})
      return
    } catch (e) {
      if (checkInMaintenance(e)) {
        // メンテナンス中の場合は何もしない
        return
      }
    }
  }
}
</script>

<style scoped>
.maintenance__wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}
</style>
